import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import _ from "lodash";
//引入iview
import iView from "view-design";
import "view-design/dist/styles/iview.css";
Vue.use(iView);
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
import { ShareSheet } from "vant";
Vue.use(ShareSheet);
// import { List } from 'vant';
// import 'vant/lib/index.css'
// Vue.use(List);
import Share from "vue-social-share"; //分享插件
import "vue-social-share/dist/client.css";
Vue.use(Share);
import "@/utils/response.js";

// 引入全局css
import "./assets/global.css";
// 暴露全局请求方法
import api from "./core/tsg_api/config/index";
Vue.use(api);

import QRCode from "qrcodejs2";
Vue.prototype.$qrCode = QRCode;
// import apiList from '@/core/zwzsw_api/config/index'
// Vue.use(apiList)
import * as echarts from "echarts";
// Vue.use(echarts)
Vue.prototype.$echarts = echarts;

// 引入 Vconsole
import Vconsole from "vconsole";
// new Vconsole();
// 在 test 环境才使用
process.NODE_ENV === "test" ? new Vconsole() : "";

//页面
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  window.scrollTo(0, 0);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  },
});
//注册全局通用属性,方法
import global from "@/core/global/global";
Vue.use(global);
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  data: {
    Bus: new Vue(),
  },
  render: (h) => h(App),
}).$mount("#app");
